import { reduxForm } from 'redux-form'

import { shareByEmail } from '../actions'
import {
  getRegistryId,
  getRegistryShareUrl,
  getRegistryTitle,
  getUserFullName,
} from 'registry/reducers'
import ShareByEmailForm, {
  defaultMessage,
  validate,
} from '../components/share-by-email-form'

export default reduxForm(
  {
    form: 'shareByEmail',
    fields: ['fromName', 'copyMe', 'message', 'toEmails', 'registryId'],
    validate,
  },
  (state, ownProps) => {
    return {
      initialValues: {
        copyMe: false,
        fromName: getUserFullName(state),
        message: defaultMessage(getUserFullName(state)),
        registryId: getRegistryId(state),
      },
      registryTitle: getRegistryTitle(state),
      registryShareUrl: getRegistryShareUrl(state),
    }
  }
)(ShareByEmailForm)
